"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModulesCacheFileSchema = exports.ModulesCacheSkippedInstanceSchema = exports.ModulesCacheSkipReason = exports.ModulesCacheEntrySchema = exports.MODULES_CACHE_SCHEMA_VERSION = void 0;
const zod_1 = require("zod");
const ModelBase_1 = require("./ModelBase");
exports.MODULES_CACHE_SCHEMA_VERSION = 2;
exports.ModulesCacheEntrySchema = zod_1.z.object({
    key: zod_1.z.string(),
    designId: zod_1.z.string(),
    designModelType: ModelBase_1.ModelTypeSchema,
    designName: zod_1.z.string().optional(),
    ref: zod_1.z.string(),
    name: zod_1.z.string(),
    fullModuleName: zod_1.z.string().optional(),
    componentRef: zod_1.z.string(),
    footprintRef: zod_1.z.string(),
    componentName: zod_1.z.string().optional(),
    componentModelId: zod_1.z.string().optional(),
    projectModuleName: zod_1.z.string(),
    projectModuleValue: zod_1.z.string().optional(),
    projectModuleIsDnp: zod_1.z.boolean().optional(),
    catalogRef: zod_1.z.string().optional(),
    multiInstanceId: zod_1.z.string().optional(),
    pinNets: zod_1.z.record(zod_1.z.string(), zod_1.z.string()),
    pinCount: zod_1.z.number().int().nonnegative(),
});
var ModulesCacheSkipReason;
(function (ModulesCacheSkipReason) {
    ModulesCacheSkipReason["DesignMissing"] = "design_missing";
    ModulesCacheSkipReason["DesignModuleMissing"] = "design_module_missing";
})(ModulesCacheSkipReason || (exports.ModulesCacheSkipReason = ModulesCacheSkipReason = {}));
exports.ModulesCacheSkippedInstanceSchema = zod_1.z.object({
    projectModuleName: zod_1.z.string(),
    componentRef: zod_1.z.string(),
    designId: zod_1.z.string(),
    ref: zod_1.z.string(),
    reason: zod_1.z.nativeEnum(ModulesCacheSkipReason),
    designModelType: ModelBase_1.ModelTypeSchema.optional(),
});
exports.ModulesCacheFileSchema = zod_1.z.object({
    projectModelId: zod_1.z.string(),
    schemaVersion: zod_1.z.literal(exports.MODULES_CACHE_SCHEMA_VERSION),
    generatedAt: zod_1.z.string(),
    entries: exports.ModulesCacheEntrySchema.array(),
    skippedInstances: exports.ModulesCacheSkippedInstanceSchema.array(),
});
//# sourceMappingURL=ModulesCacheFile.js.map